import { render, staticRenderFns } from "./CbrAccPage.vue?vue&type=template&id=229fb12a&lang=pug"
import script from "./CbrAccPage.vue?vue&type=script&lang=js"
export * from "./CbrAccPage.vue?vue&type=script&lang=js"
import style0 from "./CbrAccPage.vue?vue&type=style&index=0&id=229fb12a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports